module.exports = __webpack_public_path__ + "static/endsandstemsLogo-da80ddfe8cf7b2d0128aba4925454a73.png";